<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Input/NewDInputPreview'
export default {
  name: 'NewDEmailPreview',
  extends: compoment
}
</script>
